import { render, staticRenderFns } from "./articleList.vue?vue&type=template&id=55fc7269&scoped=true"
import script from "./articleList.vue?vue&type=script&lang=js"
export * from "./articleList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/articleList.scss?vue&type=style&index=0&id=55fc7269&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fc7269",
  null
  
)

export default component.exports